import type {ComponentEnhancer} from 'recompose'
import {branch} from 'recompose'

import {SvgIcon} from '@jetbrains/teamcity-ui/dist/components'
import classnames from 'classnames'
import compose from 'lodash/flowRight'
import * as React from 'react'

import {withVisibility} from '../Visible/Visible.hocs'

import {allIconNames, getIconAndClassNames} from './automaton'

import iconStyles from './Icon.module.css'

export const allIcons = allIconNames
type Size = 'S' | 'M'
type OwnProps = {
  name: string
  className?: string
  isVisible?: boolean
  size?: Size
  title?: string
  'aria-label'?: string
}
type Props = OwnProps & {
  size: Size
}

class Icon extends React.PureComponent<Props> {
  static defaultProps = {
    size: 'S',
  }

  render() {
    const {name, className, isVisible, size, ...restProps} = this.props
    const isSvgSource = /^<svg/.test(name)
    const [myIcon, classes] = isSvgSource ? [null, ''] : getIconAndClassNames(name, size === 'M')
    const allClasses = classnames(iconStyles.tcIcon, className, classes, {
      [iconStyles.animate]: isVisible,
    })
    const iconName = size === 'M' && !isSvgSource ? `${name}-20px` : name
    const icon = myIcon ?? iconName
    const iconProps = {...restProps, icon, 'data-test-icon': isSvgSource ? undefined : name}
    const withPerson = !isSvgSource && (name.match('personal_running') || name.match('my_running'))
    const isDebug = !isSvgSource && name.match('bug_running')
    const detached = !isSvgSource && name.match('detached')

    if (withPerson || detached || isDebug) {
      return (
        <div className={classnames(allClasses, iconStyles.wrapper)}>
          <SvgIcon
            {...iconProps}
            className={classnames((withPerson || isDebug) && iconStyles.staticPerson)}
          />
          <SvgIcon
            {...iconProps}
            className={classnames({
              [iconStyles.detached]: !withPerson && !isDebug,
              [iconStyles.spinningPerson]: withPerson,
              [iconStyles.animate]: isVisible,
              [iconStyles.spinningDebug]: isDebug,
            })}
          />
        </div>
      )
    }

    switch (name) {
      case 'build_chain':
      case 'dropdownTrigger':
      case 'dropdownTriggerSpecial':
        return <span {...restProps} className={allClasses} />

      default:
        return <SvgIcon {...iconProps} className={allClasses} />
    }
  }
}

export default compose(
  React.memo,
  branch(
    (props: Props) => props.name.includes('running'),
    withVisibility(null, 'span') as ComponentEnhancer<Props, Props>,
  ),
)(Icon)
